module.exports = __webpack_public_path__ + "static/NotoSans-Light-da834cccecc000b70e0a937245b53d9b.ttf";